import { FormForType, formFor, Validators } from "fw-model";
const { required, wrap, isEmail } = Validators;

import { EmailTemplate, EmailTemplateSendEmail, EmailTemplateTestEmail } from "models/email-template";
import { isValidKey, noNewLines } from "./validators";
import { emailContactFormCreator } from "./email-contact";

export type FormForEmailTemplate = FormForType<EmailTemplate>;
export type FormForEmailTemplateSendEmail = FormForType<EmailTemplateSendEmail>;

export class UpdateEmailTemplateAction {
  constructor(public form: FormForEmailTemplate) { }
}

export class DeleteCustomTemplateAction {
  constructor(public templateKey: string) { }
}

export class SendEmailTemplateAction {
  constructor(public form: FormForEmailTemplateSendEmail) { }
}

const requiredIf = () => {
  return (input, model) => {
    return (
      model.IsCustomKey || model.Key !== "OrganizationMaster"
        ? required(input)
        : null
    );
  };
};

export const emailTemplateFormCreator = formFor(EmailTemplate, s => {
  s.requiredField(et => et.Html, "Html Content");
  s.requiredField(et => et.Text, "Text Content");
  s.field(et => et.Subject, "Subject", wrap(noNewLines, requiredIf()));
  s.field(et => et.Name, "Name");
  s.requiredField(et => et.Key, "Template Key", v => v.if(t => t.IsCustomKey, isValidKey));
  s.field(et => et.Cc, "CC");
  s.field(et => et.Bcc, "BCC");
  s.field(et => et.Template, "Template");

  s.form(et => et.From, "From", emailContactFormCreator());
  s.form(et => et.ReplyTo, "Reply To", emailContactFormCreator());
});

export const oneOffEmailTemplateFormCreator = formFor(EmailTemplate, s => {
  s.requiredField(et => et.Html, "Html Content");
  s.requiredField(et => et.Text, "Text Content");
  s.field(et => et.Subject, "Subject", wrap(noNewLines, requiredIf()));
  s.field(et => et.Name, "Name");
  s.field(et => et.Cc, "CC");
  s.field(et => et.Bcc, "BCC");
  s.field(et => et.Template, "Template");

  s.form(et => et.From, "From", emailContactFormCreator(true, true));
  s.form(et => et.ReplyTo, "Reply To", emailContactFormCreator());
});

export const emailTemplateTestEmailFormCreator = formFor(EmailTemplateTestEmail, s => {
  s.requiredField(et => et.EmailAddress, "Email Address", wrap(isEmail));
});

export const emailTemplateSendEmailFormCreator = formFor(EmailTemplateSendEmail, s => {
  s.requiredField(et => et.Html, "Html Content");
  s.field(et => et.Text, "Text Content");
  s.requiredField(et => et.Subject, "Subject", wrap(noNewLines));
  s.requiredField(et => et.To, "To");
  s.requiredField(et => et.From, "From");
  s.requiredField(et => et.ReplyTo, "ReplyTo");
  s.field(et => et.Cc, "CC");
  s.field(et => et.Bcc, "BCC");
  s.field(et => et.Tokens, "Tokens");
  s.formArray(et => et.TestEmails, "Test Emails", emailTemplateTestEmailFormCreator);
  s.field(et => et.EmailAttachments, "Email Attachments");
});